<script>
export default {
  name: "MinionTable",
  props: {
    data: Array,
    loading: Boolean,
  },
  data() {
    return {

    }
  },
  methods: {
    getStatusLabel(deleted_at) {
      if(!deleted_at) return 'Включен'
      const date = new Date(deleted_at)
      return `Выключен (${date.toLocaleDateString()})`
    }
  }
}
</script>

<template>
  <b-table
    :data="data"
    :loading="loading"
    hoverable
    striped
    class="minions-table"
  >
    <b-table-column field="type.name" label="Название" v-slot="props">
      {{ props.row.type.name }}
    </b-table-column>
    <b-table-column field="deleted_at" label="Статус" v-slot="props" centered width="120px">
      {{ getStatusLabel(props.row.deleted_at) }}
    </b-table-column>
    <b-table-column label="Опции" v-slot="props" centered width="120px">
        <b-button
          class="mr-2"
          size="is-small"
          :type="!props.row.deleted_at ? 'is-info is-outlined' : 'is-info'"
          @click="$emit('changeStatus', props.row.id, !!props.row.deleted_at)"
        >{{ props.row.deleted_at ? 'Включить' : 'Выключить' }}</b-button>
    </b-table-column>
<!--    <b-table-column field="msg" label="Последнее сообщение" v-slot="props" width="40%">-->
<!--      <b-tooltip-->
<!--        position="is-top"-->
<!--        square-->
<!--        type="is-primary is-light"-->
<!--      >-->
<!--        <div class="is-ellipsis">{{ props.row.msg || '-' }}</div>-->
<!--        <template #content>-->
<!--          <pre>{{ props.row.msg || '-' }}</pre>-->
<!--        </template>-->
<!--      </b-tooltip>-->
<!--    </b-table-column>-->
    <template #empty>
      <div class="has-text-centered">{{ loading ? 'Загрузка...' : 'Нет данных' }}</div>
    </template>
  </b-table>
</template>

<style lang="scss">
.minions-table {
  td {
    vertical-align: middle;
  }
}

.is-justify-items-right {
  justify-items: right;
}
</style>
